import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { AdminContext } from "context/AdminContext";

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const { state } = useContext(AdminContext);
  const { adminInfo } = state;
  const isAuthenticated = Boolean(adminInfo?.email && adminInfo?.token);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          Component ? (
            <Component {...props} />
          ) : (
            children
          )
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
